import { ref,reactive } from 'vue'
import axios from "axios";
import { useRoute } from 'vue-router';
import Auth from './auth';
export default function useNotification() {
    const notifications = ref([])
    const notification = ref({})
    const loading = ref(true)
    const meta = reactive({})
    const errors = ref('')

    const getNotifications = async (p = 1) => {
        try {
            if(p == 1)delete meta.current_page;
            errors.value = '';
            loading.value = true;
            let response = await axios.get('notification?page=' + p)
            loading.value = false;
            if(p == 1) notifications.value = response.data.data;
            else notifications.value.push(...response.data.data);
            Object.assign(meta,response.data.meta);
        }catch (e){
            errors.value = e;
            loading.value = false;
        }
    }

    const destroy = async (id) => {
        try {
          errors.value = "";
          progressDialog.value = true;
          let response = await axios.delete("notification" + (id ? '/' + id : ''));
          progressDialog.value = false;
          toast.success(response.data.message);
          if(id)notifications.value = notifications.value.filter(item => id != item.id);
          else getNotifications();
        } catch (e) {
          window.networkError(e);
          progressDialog.value = false;
        }
      };

    const mark = async (id) => {
        try {
            notification.value = null;
            document.getElementById('notification').checked = false;
            let response = await axios.put('notification/mark',{id});
            Auth.user.value.notification_count = response.data.count;
            let index = notifications.value.findIndex(item => item.id === id);
            if (index > -1)notifications.value[index].read_at = Date.now();
        }catch (e){}
    }

    return {
        errors,
        loading,
        destroy,
        getNotifications,
        meta,
        mark,
        notifications,
        notification,
    }
}